<template>
	<vue-pdf-embed
		ref="pdf-view"
		class="pdf-view"
		:class="[mode, childWrapper]"
		:source="pdfInitOpts"
		:page="page"
		:text-layer="showTextLayer"
		:height="height"
		:width="width"
		v-bind="$attrs"
	>
		<template #before-page="slotProps">
			<slot name="before-page" v-bind="slotProps" />
		</template>
		<template #after-page="slotProps">
			<slot name="after-page" v-bind="slotProps" />
		</template>
	</vue-pdf-embed>
	<div v-if="limitPages && !showAllPages" class="text-center py-4">
		<button
			class="px-4 py-2 text-white rounded text-sm"
			style="background-color: #9250e9"
			@click="showAllPages = true"
		>
			Alle pagina's laden (groot bestand)
		</button>
		<p class="mt-1 text-xs" style="color: #81838c">
			Alleen pagina 1 wordt getoond om geheugengebruik te beperken
		</p>
	</div>
</template>

<script lang="ts" setup>
import { computed, ref, useTemplateRef } from "vue";
import VuePdfEmbed from "vue-pdf-embed";
import { useElementSize } from "@vueuse/core";
import "vue-pdf-embed/dist/styles/annotationLayer.css";
import "vue-pdf-embed/dist/styles/textLayer.css";

const props = withDefaults(
	defineProps<{
		url: string;
		mode?: "full" | "thumbnail";
		pageWrapper?: "AppCard" | "div";
		limitPages?: boolean;
	}>(),
	{ mode: "full", pageWrapper: "div", limitPages: false },
);

const showAllPages = ref(false);

const pdfView = useTemplateRef("pdf-view");

const { width: pdfViewWidth } = useElementSize(() => pdfView.value?.$el);
const width = computed(() => {
	if (props.mode === "thumbnail") {
		return;
	}

	return pdfViewWidth.value;
});

const pdfInitOpts = computed(() => {
	return {
		url: props.url,
		isEvalSupported: false,
	};
});

const showTextLayer = computed(() => {
	return props.mode !== "thumbnail";
});

const page = computed(() => {
	if (props.mode === "thumbnail") return 1;
	if (props.limitPages && !showAllPages.value) return 1;
	return undefined;
});

const height = computed(() => {
	return props.mode === "thumbnail" ? 200 : undefined;
});

const childWrapper = computed(() =>
	props.pageWrapper === "AppCard" ? "pdf-child-app-card" : null,
);
</script>

<style lang="scss">
@use "@/style/mixins.scss" as mixins;

.pdf-view {
	width: 100%;
	height: 100%;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	row-gap: 25px;

	&.thumbnail {
		justify-content: center;

		.vue-pdf-embed__page {
			width: 100%;
			height: 100%;
		}

		> div {
			position: relative;
			width: 100%;
			height: 100%;

			canvas {
				max-width: 100%;
				margin: 0 auto;
				max-height: 100%;

				// :( (vue-pdf-embed overrides the width and height props on the canvas. By doing this we override it back)
				height: unset !important;
				width: unset !important;
			}
		}
	}

	&.pdf-child-app-card > div {
		@include mixins.app-card;
		align-self: center;
		position: relative;
		width: fit-content;
		max-width: 100%;

		overflow: hidden;
	}
}
</style>
